import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const Chart = ({ data, locale, recharts }) => {
  const {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    LabelList,
    ResponsiveContainer,
  } = recharts;
  return (
    <ResponsiveContainer width={900} height={500} className="line-chart">
      <LineChart
        data={data}
        margin={{
          top: 40,
          right: 30,
          left: 20,
          bottom: 40,
        }}
      >
        <CartesianGrid />
        <XAxis
          dataKey="name"
          style={{ fontSize: '60%' }}
          tickLine={{ stroke: 'rgb(204, 204, 204)' }}
          axisLine={{ stroke: 'rgb(204, 204, 204)' }}
          tickSize={24}
        />
        <YAxis
          type="number"
          style={{ fontSize: '60%' }}
          tickLine={false}
          axisLine={{ stroke: 'rgb(204, 204, 204)' }}
          tickFormatter={(value, index) =>
            index === 7 ? '' : Intl.NumberFormat(locale, {}).format(value)
          }
          tickSize={20}
          tickCount={9}
          domain={([dataMin, dataMax]) => [Math.min(0, dataMin), dataMax * 2]}
          interval={0}
        />
        <Line dataKey="v0" stroke="#6CB9DC" dot={false} strokeWidth={5}>
          <LabelList
            dataKey="v0"
            position="top"
            stroke="#000000"
            style={{ fontSize: '80%' }}
            offset={10}
            formatter={(value) => Intl.NumberFormat(locale, {}).format(value)}
          />
        </Line>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default injectLazyLibs('recharts')(Chart);
